import axios from 'axios';
import { api } from '../util/urlConfig';

const token = localStorage.getItem('token');

const axiosInstance = axios.create({
    baseURL: api,
    // header: {
    //     Authorization: token
    // }
})

export default axiosInstance;